var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeAction = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
  d: "M10.667 1.375C11.7486 1.37518 12.6248 2.25142 12.625 3.33301V12.667C12.6248 13.7486 11.7486 14.6248 10.667 14.625H5.33301C4.25142 14.6248 3.37518 13.7486 3.375 12.667V3.33301C3.37518 2.25142 4.25142 1.37518 5.33301 1.375H10.667Z",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.16667 4H8.83333",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export default SvgTypeAction;